
(function () {
    window.factionService = {
      get() {
        return axios.get(`/api/faction/get.php`);
      },
      getUserFaction() {  
        return axios.get(`/api/user/faction/get.php?twitchId=${utils.cookies.get('user_id')}`);
      },
      getFaction(id){
        return axios.get(`/api/faction/get.php?id=${id}`);
      },
      getTeam(id) {  
        return axios.get(`/api/user/faction/get.php?twitchId=${utils.cookies.get('user_id')}&&id=${id}`);
      },
      save(data) {
        return axios.post('/api/faction/save.php', data);
      },
      userSave(data) {
        return axios.post('/api/user/faction/save.php', data);
      },
      userRemove(id){
        return axios.post('/api/faction/remove.php', {'id': id});
      },
      getFactionStats(id){
        return axios.get(`/api/user/faction/get.php?fid=${id}&&twitchId=${utils.cookies.get('user_id')}`);
      },
      getFactionHistory(id){
        return axios.get(`/api/user/faction/get.php?fhid=${id}&&twitchId=${utils.cookies.get('user_id')}`);
      },
      leave(data){
        return axios.post('/api/user/faction/save.php', data);
      }
    };
  })();
  